// ABOUTME: Constants for admin user impersonation feature
// ABOUTME: Shared constants used across impersonation hook, API client, and components

export const IMPERSONATION_CONSTANTS = {
  // Session storage key for persisting impersonation state
  STORAGE_KEY: 'impersonatedUser',

  // HTTP header name for impersonation user ID
  HEADER_NAME: 'X-Impersonate-User-Id',

  // Error messages
  ERROR_ADMIN_ONLY: 'Only administrators can impersonate users',
} as const;
